import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Layout, Row, Col, Divider } from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { authService } from '../services/authService';

const { Title, Text } = Typography;
const { Content } = Layout;

interface LoginProps {
  onLogin: (response: any) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    setError('');

    try {
      const response = await authService.login(values);
      onLogin(response);
    } catch (err: any) {
      let errorMessage = 'Đăng nhập thất bại';
      
      if (err.response?.data) {
        if (typeof err.response.data === 'object') {
          errorMessage = err.response.data.title || err.response.data.message || errorMessage;
        } else {
          errorMessage = err.response.data;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center'
      }}>
        {/* Logo and Welcome Section */}
        <div style={{ marginBottom: 32, textAlign: 'center' }}>
          <img 
            src="/logo192.png" 
            alt="Phủ Diễn Portal" 
            style={{ 
              height: '100px', 
              marginBottom: '16px',
              borderRadius: '50%',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }} 
          />
          <Title level={2} style={{ margin: 0, color: '#1890ff' }}>
            PHỦ DIỄN PORTAL
          </Title>
          <Text type="secondary" style={{ fontSize: '16px' }}>
            Chào mừng đến với Hệ thống Quản lý ERP
          </Text>
        </div>

        <Card 
          style={{ 
            width: '100%', 
            maxWidth: 400,
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <Title level={3} style={{ marginBottom: 8 }}>
              <LoginOutlined style={{ marginRight: 8 }} />
              Đăng nhập
            </Title>
            <Divider style={{ margin: '16px 0' }} />
          </div>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ marginBottom: 24 }}
            />
          )}

          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập!' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Tên đăng nhập"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Mật khẩu"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                size="large"
                style={{ width: '100%' }}
              >
                {loading ? 'Đang đăng nhập...' : 'Đăng nhập'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default Login;